import React, { FC } from "react";
import { Button, createStyles, Dialog, DialogActions, DialogTitle, Grid, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fullWidth: {
        width: '100%',
    },

    helperText: {  
      fontStyle: "italic",
      fontSize: "10px",
    },

    buttonStyles: {
      flexDirection: "column",
    }
  }),
);

interface SaveDialogProps {
  open: boolean;
  title: string;
  currStatus: number;
  onCloseCancel: () => void;
  onCloseSubmit: () => void;
  onReceipt: () => void;
  onMailReceipt?: () => void;
  onResend?: () => void;
  onSendConfimationEmail: () => void;
  onSendDenialEmail: () => void;
  // content: React.FC<{}>;//JSX.Element;
}

const SaveDialog: FC<SaveDialogProps> = ({ onCloseCancel, onCloseSubmit, onReceipt, onMailReceipt, onResend, onSendConfimationEmail, onSendDenialEmail, currStatus, children, open, title }) => {
    const classes = useStyles();

  return (
    <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        className={classes.fullWidth}
      >
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} >
            <DialogTitle id="dialog-title">{title}</DialogTitle>
          </Grid>
          </Grid>
        {children}
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item container spacing={2} xs={4}>
              <Grid item xs={12} >
                <Button fullWidth variant="contained" onClick={onSendConfimationEmail} style={{backgroundColor: "green", color: "white"}}>
                  Godkend
                </Button>
                  <div className={classes.helperText}>
                    Godkend og send mail til ansøger.
                  </div>
              </Grid>
              <Grid item xs={12} >
                <Button fullWidth variant="contained" onClick={onSendDenialEmail} style={{backgroundColor: "red", color: "white"}}> 
                  Afvis
                </Button>
                <div className={classes.helperText}>
                  Afvis og send mail til ansøger.
                </div>
              </Grid>
              <Grid item xs={12} >
                <Button fullWidth variant="contained" color="primary" onClick={onResend} > 
                  Gensend mail
                </Button>
                <div className={classes.helperText} style={{minHeight: "30px"}}>
                  Gem evt. ændringer og send mail til ansøger.
                </div>
              </Grid>
            </Grid>
            <Grid item container spacing={2} xs={4} style={{display: "flex", flexDirection: "column" ,justifyContent: "flex-end"}}>
              <Grid item>
              <Grid item sm={12} style={{display: "flex", flexDirection: "column", justifyContent: "flex-end"}} >
                { currStatus > 1
                ?(<>
                <Button fullWidth variant="contained" color="primary" onClick={onReceipt} > 
                  Åbn tilladelse
                </Button>
                <div className={classes.helperText} style={{minHeight: "30px"}}>
                  Se den nuværende tilladelse.
                </div>
                </>):(<>
                <Button fullWidth variant="contained" style={{backgroundColor: "grey", color: "white"}} onClick={onReceipt} > 
                  Åbn tilladelse
                </Button>
                <div className={classes.helperText} style={{minHeight: "30px"}}>
                  Se udkast til tilladelsen.
                </div>
                </>)
                }
              </Grid>
              <Grid item sm={12} style={{display: "flex", flexDirection: "column", justifyContent: "flex-end"}} >
                { currStatus >= 4
                ?(<>
                <Button fullWidth variant="contained" color="primary" onClick={onMailReceipt} > 
                  Kvittering
                </Button>
                <div className={classes.helperText} style={{minHeight: "30px"}}>
                  Download kvittering.
                </div>
                </>):(<></>)
                }
              </Grid>
            </Grid>
            </Grid>
              <Grid item container spacing={2} xs={4} style={{display: "flex", flexDirection: "column" ,justifyContent: "flex-end"}} >
                <Grid item  >
                  <Grid item xs={12}   >
                    <Button fullWidth onClick={onCloseSubmit} color="primary">
                      Gem
                    </Button>
                    <div className={classes.helperText}>
                      {(currStatus <= 1)
                      ?(<>Gem uden at sende en mail til ansøger</>)
                      :(<>Gem og send en mail til ansøger</>)
                      } 
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Button fullWidth onClick={onCloseCancel} color="primary">
                      Annuller
                    </Button>
                    <div className={classes.helperText} style={{minHeight: "30px"}}>
                      Forlad uden at gemme ændringer.
                    </div>
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
  );
}

export default SaveDialog;